module.exports = __webpack_public_path__ + "static/img/rotten_mangonel.9e4f973.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/rotten_mangonel.png
// module id = 5tKx
// module chunks = 0